export const fireMiraklImpression = products => {
  if (!products) return
  const adId = products?.collection
    ?.filter(it => it.adId)
    ?.map(it => it.adId)
    ?.join('|')
  if (!adId) return
  fireEvent('impression', { adId })
}

export const fireMiraklClick = adId => {
  if (!adId) return
  fireEvent('click', { adId })
}

const fireEvent = (eventType, data) => {
  if (window?.miraklTag) return window?.miraklTag?.event(eventType, data)
  // mirakl js may load lately, so we postpone the event a bit
  setTimeout(() => window?.miraklTag?.event(eventType, data), 3000)
}
